import CheckboxControl from '../../form_controls/CheckboxControl'
import NumberControl from '../../form_controls/NumberControl'
import PercentageControl from '../../form_controls/PercentageControl'
import SelectControl from '../../form_controls/SelectControl'
import SelectManyControl from '../../form_controls/SelectManyControl'
import TextControl from '../../form_controls/TextControl'
import TextAreaControl from '../../form_controls/TextAreaControl'
import SignatureControl from '../../form_controls/SignatureControl'
import TimerControl from '../../form_controls/TimerControl'
import DataGridControl from '../../form_controls/grids/DataGridControl'
import DynamicDataGridControl from '../../form_controls/grids/DynamicDataGridControl'
import FixedDataGridControl from '../../form_controls/grids/FixedDataGridControl'
import { IControlProps } from '../../form_controls/types'
import SubtotalControl from '../../form_controls/SubtotalControl'
import DynamicDataListControl from '../../form_controls/grids/DynamicDataListControl'
import FormulaControl from '../../form_controls/FormulaControl'
import CanvasControl from '../../form_controls/CanvasControl'
import AntdDateControl from '../../form_controls/AntdDateControl'
import AntdDateTimeControl from '../../form_controls/AntdDateTimeControl'
import AntdTimeControl from '../../form_controls/AntdTimeControl'
import AutoCompleteControls, {
  AUTOCOMPLETE_CONTROL_TYPES,
  AutoCompleteFieldName
} from '../../form_controls/AutoCompleteControls'
import { IChecklistField } from '../../../models/Checklist'
import { UnsupportedControl } from '../../form_controls/UnsupportedControl'

export const fieldControls: {
  [questionType: string]: React.ComponentType<IControlProps>
} = {
  checkbox: CheckboxControl,
  date: AntdDateControl,
  datetime: AntdDateTimeControl,
  number: NumberControl,
  percentage: PercentageControl,
  select: SelectControl,
  select_many: SelectManyControl,
  text: TextControl,
  textarea: TextAreaControl as any,
  yesno: SelectControl,
  signature: SignatureControl,
  timer: TimerControl,
  datagrid: DataGridControl,
  fixeddatagrid: FixedDataGridControl as any,
  information: () => null,
  subtotal: SubtotalControl,
  dynamicdatalist: DynamicDataListControl as any,
  dynamicdatagrid: DynamicDataGridControl as any,
  formula: FormulaControl as React.ComponentType<IControlProps>,
  time: AntdTimeControl,
  photo: CanvasControl as React.ComponentType<IControlProps>,
  autoCompleteControls:
    AutoCompleteControls as React.ComponentType<IControlProps>
}

export const findControl = (
  question: IChecklistField
): React.ComponentType<IControlProps> => {
  const customField = question.mappingField?.value as string
  const questionType = question.type
  let control = null
  
  if (
    questionType === 'placeholder' &&
    AUTOCOMPLETE_CONTROL_TYPES.includes(customField as AutoCompleteFieldName)
  ) {
    control = fieldControls['autoCompleteControls']
  } else if (questionType === 'placeholder') {
    control = fieldControls['select']
  } else {
    control = fieldControls[questionType]
  }
  return control || UnsupportedControl
}
